// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_analyst_status */
var FoodSensoryAnalystStatus;
(function (FoodSensoryAnalystStatus) {
    FoodSensoryAnalystStatus["pending"] = "pending";
    FoodSensoryAnalystStatus["completed"] = "completed";
})(FoodSensoryAnalystStatus || (FoodSensoryAnalystStatus = {}));
;
export default FoodSensoryAnalystStatus;
/** Zod schema for food_sensory_analyst_status */
export const foodSensoryAnalystStatus = z.nativeEnum(FoodSensoryAnalystStatus);
//# sourceMappingURL=FoodSensoryAnalystStatus.js.map